document.addEventListener('DOMContentLoaded', () => {
  const openerItems = document.querySelectorAll('.main-navigation_dropdown-opener');

  openerItems.forEach(opener => {
    const parentItem = opener.closest('li') || opener.parentElement;
    const dropdownContent = parentItem.querySelector('.dropdown-component_content');
    const toggleBtn = parentItem.querySelector('.dropdown-toggle');

    if (!dropdownContent) return;

    // Einheitliche Klick-Steuerung für Desktop und Mobile
    const handleClick = (e) => {
      e.preventDefault(); // Verhindert, dass der Link eine neue Seite lädt
      
      // Schließt andere offene Menüs auf derselben Ebene
      document.querySelectorAll('.dropdown-component_content.is-open').forEach(openMenu => {
        if (!openMenu.contains(dropdownContent) && openMenu !== dropdownContent) {
          openMenu.classList.remove('is-open');
        }
      });

      // Öffnet oder schließt das angeklickte Menü
      dropdownContent.classList.toggle('is-open');
    };

    // Prüft, ob ein spezielles Icon (+ oder Pfeil) zum Klicken da ist, ansonsten nimmt er den Text
    if (toggleBtn) {
      toggleBtn.addEventListener('click', handleClick);
    } else {
      opener.addEventListener('click', handleClick);
    }
  });

  // Schließt alle Menüs, wenn außerhalb der Navigation geklickt wird
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.main-navigation_dropdown-opener') && !e.target.closest('.dropdown-component_content')) {
      document.querySelectorAll('.dropdown-component_content.is-open').forEach(menu => {
        menu.classList.remove('is-open');
      });
    }
  });
});
document.addEventListener('DOMContentLoaded', () => {
  const openerItems = document.querySelectorAll('.main-navigation_dropdown-opener');

  openerItems.forEach(opener => {
    const parentItem = opener.closest('li') || opener.parentElement;
    const dropdownContent = parentItem.querySelector('.dropdown-component_content');
    const toggleBtn = parentItem.querySelector('.dropdown-toggle');

    if (!dropdownContent) return;

    // Einheitliche Klick-Steuerung für Desktop und Mobile
    const handleClick = (e) => {
      e.preventDefault(); // Verhindert, dass der Link eine neue Seite lädt
      
      // Schließt andere offene Menüs auf derselben Ebene
      document.querySelectorAll('.dropdown-component_content.is-open').forEach(openMenu => {
        if (!openMenu.contains(dropdownContent) && openMenu !== dropdownContent) {
          openMenu.classList.remove('is-open');
        }
      });

      // Öffnet oder schließt das angeklickte Menü
      dropdownContent.classList.toggle('is-open');
    };

    // Prüft, ob ein spezielles Icon (+ oder Pfeil) zum Klicken da ist, ansonsten nimmt er den Text
    if (toggleBtn) {
      toggleBtn.addEventListener('click', handleClick);
    } else {
      opener.addEventListener('click', handleClick);
    }
  });

  // Schließt alle Menüs, wenn außerhalb der Navigation geklickt wird
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.main-navigation_dropdown-opener') && !e.target.closest('.dropdown-component_content')) {
      document.querySelectorAll('.dropdown-component_content.is-open').forEach(menu => {
        menu.classList.remove('is-open');
      });
    }
  });
});

// --------------------------------------------------------
// DPG-PFAND TELEPORTATION (UPDATESICHER MIT SCHLEIFENBREMSE)
// --------------------------------------------------------
function teleportPfand() {
  const taxElement = document.querySelector('.product_tax');
  const pfandBox = document.getElementById('updatesafe-pfand-container');
  
  if (taxElement && pfandBox) {
    // SCHLEIFENBREMSE: Nur verschieben, wenn es nicht schon exakt dort sitzt!
    if (taxElement.nextSibling !== pfandBox) {
      taxElement.parentNode.insertBefore(pfandBox, taxElement.nextSibling);
      pfandBox.style.display = 'block';
    }
  }
}

// Skript bei jedem Laden der Seite ausführen
document.addEventListener('DOMContentLoaded', teleportPfand);
window.addEventListener('load', teleportPfand);

// Falls das Theme bei Varianten-Wechseln den Preis-Block neu lädt
if (document.body) {
  const pfandObserver = new MutationObserver(teleportPfand);
  pfandObserver.observe(document.body, { childList: true, subtree: true });
}
// --------------------------------------------------------
// PRODUKTBESCHREIBUNG ACCORDIONS (H5) UPDATESICHER
// --------------------------------------------------------
function initDescriptionAccordions() {
  const descContainer = document.querySelector('.main-product_description-block');
  if (!descContainer) return;

  const headings = descContainer.querySelectorAll('h5');
  headings.forEach(heading => {
    if (heading.dataset.accordionInit) return;
    if (heading.textContent.trim() === "") return;
    
    heading.dataset.accordionInit = "true";
    heading.classList.add('description-accordion-title');

    let siblings = [];
    let next = heading.nextElementSibling;
    while (next && next.tagName !== 'H5') {
      siblings.push(next);
      next = next.nextElementSibling;
    }

    siblings.forEach(el => el.style.display = 'none');

    heading.addEventListener('click', () => {
      heading.classList.toggle('is-open');
      siblings.forEach(el => {
        el.style.display = el.style.display === 'none' ? '' : 'none';
      });
    });
  });
}

document.addEventListener('DOMContentLoaded', initDescriptionAccordions);
window.addEventListener('load', initDescriptionAccordions);

if (document.body) {
  const descObserver = new MutationObserver(initDescriptionAccordions);
  descObserver.observe(document.body, { childList: true, subtree: true });
}